import React from 'react';
import BaseTabComponent from "../BaseTabComponent";

const adminFeeCellIndex = 2;
const camCheckboxCellIndex = 3;
const camCellIndex = 4;
const mgmtCheckboxCellIndex = 5;
const mgmtCellIndex = 6;
const insuranceCheckboxCellIndex = 7;
const insuranceCellIndex = 8;
const taxesCheckboxCellIndex = 9;
const taxesCellIndex = 10;

export default class CurrentReimbursement extends BaseTabComponent {
    constructor(props) {
        super(props);

        this.state = {
        };

        this.defaultTableRef = React.createRef();

        this.onTableValueChange = this.onTableValueChange.bind(this);
    }

    componentDidMount() {
        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.props.tabs);
        // Compute Reimbursement Types values
        this.computeReimbTypes(this.props.tab, this.props.tabs, precomputedValues, this.props.sqFtUpdated, this.props.camPSFSumUpdated, this.props.mgmtUpdated, this.props.insuranceUpdated, this.props.taxesUpdated);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.tab !== nextProps.tab) {
            const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.props.tabs);
            // Compute Reimbursement Types values
            this.computeReimbTypes(nextProps.tab, this.props.tabs, precomputedValues, this.props.sqFtUpdated, this.props.camPSFSumUpdated, this.props.mgmtUpdated, this.props.insuranceUpdated, this.props.taxesUpdated);
        }
    }

    static computeCamValue(checkbox, sum) {
        if (!checkbox) {
            return 0;
        }
        return sum ? parseFloat(sum) : 0;
    }

    static computeMgmtValue(checkbox, mgmt, cam, adminFee) {
        if (!checkbox) {
            return 0;
        }
        if (!adminFee) {
            return mgmt;
        }
        const value = cam * (adminFee / 100);
        return value ? parseFloat(value) : 0;
    }

    static computeInsuranceValue(checkbox, insurance) {
        if (!checkbox) {
            return 0;
        }
        return insurance ? parseFloat(insurance) : 0;
    }

    static computeTaxesValue(checkbox, taxes) {
        if (!checkbox) {
            return 0;
        }
        return taxes ? parseFloat(taxes) : 0;
    }

    static recomputeCamByIndex(tab, tabs, precomputedValues, index, newCheckbox = null) {
        const cells = tabs[tab].tables['reimbursement-types'].rows[index].valueCells;
        const checkbox = newCheckbox === null ? cells[camCheckboxCellIndex].value : newCheckbox;
        if (!checkbox) {
            return 0;
        }
        const totalCamIndex = tab === 'current-reimbursement-tab' ? 3 : 6;
        const sum = tabs['expenses-tab'].tables['expenses'].rows['total-cam'].valueCells[totalCamIndex].getComputedValue(tabs, precomputedValues).internalValue || 0;
        return CurrentReimbursement.computeCamValue(checkbox, sum);
    }

    static recomputeMgmtByIndex(tab, tabs, precomputedValues, index, newCheckbox = null, newAdminFee = null, newCam = null) {
        const cells = tabs[tab].tables['reimbursement-types'].rows[index].valueCells;
        const checkbox = newCheckbox === null ? cells[mgmtCheckboxCellIndex].value : newCheckbox;
        if (!checkbox) {
            return 0;
        }
        const cam = newCam === null ? cells[camCellIndex].value : newCam;
        const adminFee = newAdminFee === null ? cells[adminFeeCellIndex].value : newAdminFee;
        const mgmt = tabs[tab].tables['reimbursable-op-ex'].rows['management'].valueCells[5].getComputedValue(tabs, 'management', precomputedValues).internalValue || 0;
        return CurrentReimbursement.computeMgmtValue(checkbox, mgmt, cam, adminFee);
    }

    static recomputeInsuranceByIndex(tab, tabs, precomputedValues, index, newCheckbox = null) {
        const cells = tabs[tab].tables['reimbursement-types'].rows[index].valueCells;
        const checkbox = newCheckbox === null ? cells[insuranceCheckboxCellIndex].value : newCheckbox;
        if (!checkbox) {
            return 0;
        }
        const insurance = tabs[tab].tables['reimbursable-op-ex'].rows['insurance'].valueCells[6].getComputedValue(tabs, 'insurance', precomputedValues).internalValue || 0;
        return CurrentReimbursement.computeInsuranceValue(checkbox, insurance);
    }

    static recomputeTaxesByIndex(tab, tabs, precomputedValues, index, newCheckbox = null) {
        const cells = tabs[tab].tables['reimbursement-types'].rows[index].valueCells;
        const checkbox = newCheckbox === null ? cells[taxesCheckboxCellIndex].value : newCheckbox;
        if (!checkbox) {
            return 0;
        }
        const taxes = tabs[tab].tables['reimbursable-op-ex'].rows['real-estate-taxes'].valueCells[7].getComputedValue(tabs, 'real-estate-taxes', precomputedValues).internalValue || 0;
        return CurrentReimbursement.computeTaxesValue(checkbox, taxes);
    }

    computeReimbTypes(tab, tabsData, precomputedValues, sqFtUpdated = null, camPSFSumUpdated = null, mgmtUpdated = null, insuranceUpdated = null, taxesUpdated = null) {
        const tabs = [], tables = [], rowIds = [], newValues = [], columnIds = [];
        const totalCamIndex = tab === 'current-reimbursement-tab' ? 3 : 6;
        const updated = {};
        let sum = tabsData['expenses-tab'].tables['expenses'].rows['total-cam'].valueCells[totalCamIndex].getComputedValue(tabsData, precomputedValues).internalValue;
        let mgmt = tabsData[tab].tables['reimbursable-op-ex'].rows['management'].valueCells[5].getComputedValue(tabsData, 'management', precomputedValues).internalValue;
        let insurance = tabsData[tab].tables['reimbursable-op-ex'].rows['insurance'].valueCells[6].getComputedValue(tabsData, 'insurance', precomputedValues).internalValue;
        let taxes = tabsData[tab].tables['reimbursable-op-ex'].rows['real-estate-taxes'].valueCells[7].getComputedValue(tabsData, 'real-estate-taxes', precomputedValues).internalValue;
        if (!isFinite(sum)) sum = 0;
        if (!isFinite(mgmt)) mgmt = 0;
        if (!isFinite(insurance)) insurance = 0;
        if (!isFinite(taxes)) taxes = 0;

        for (let index = 0; index < 15; index++) {
            const cells = tabsData[tab].tables['reimbursement-types'].rows[index].valueCells;
            const camChecked = cells[camCheckboxCellIndex].value;
            let camValue = cells[camCellIndex].value;
            let newCamValue = 0;
            if (camChecked && (!camValue || camPSFSumUpdated || sqFtUpdated)) {
                newCamValue = CurrentReimbursement.computeCamValue(camChecked, sum);
                if (newCamValue) {
                    tabs.push(tab);
                    tables.push('reimbursement-types');
                    rowIds.push(index);
                    newValues.push(newCamValue);
                    columnIds.push(camCellIndex);
                    if (camPSFSumUpdated) updated.camChanged = false;
                    if (sqFtUpdated) updated.sqFtChanged = false;
                }
            }

            const adminFee = cells[adminFeeCellIndex].value;
            const mgmtChecked = cells[mgmtCheckboxCellIndex].value;
            let mgmtValue = cells[mgmtCellIndex].value;
            const cam = newCamValue ? newCamValue : (camValue || 0);
            if (mgmtChecked && (!mgmtValue || mgmtUpdated)) {
                const newMgmtValue = CurrentReimbursement.computeMgmtValue(mgmtChecked, mgmt, cam, adminFee);
                if (newMgmtValue) {
                    tabs.push(tab);
                    tables.push('reimbursement-types');
                    rowIds.push(index);
                    newValues.push(newMgmtValue);
                    columnIds.push(mgmtCellIndex);
                    if (mgmtUpdated) updated.mgmtChanged = false;
                }
            }

            const insuranceChecked = cells[insuranceCheckboxCellIndex].value;
            let insuranceValue = cells[insuranceCellIndex].value;
            if (insuranceChecked && (!insuranceValue || insuranceUpdated)) {
                const newInsuranceValue = CurrentReimbursement.computeInsuranceValue(insuranceChecked, insurance);
                if (newInsuranceValue) {
                    tabs.push(tab);
                    tables.push('reimbursement-types');
                    rowIds.push(index);
                    newValues.push(newInsuranceValue);
                    columnIds.push(insuranceCellIndex);
                    if (insuranceUpdated) updated.insuranceChanged = false;
                }
            }

            const taxesChecked = cells[taxesCheckboxCellIndex].value;
            let taxesValue = cells[taxesCellIndex].value;
            if (taxesChecked && (!taxesValue || taxesUpdated)) {
                const newTaxesValue = CurrentReimbursement.computeTaxesValue(taxesChecked, taxes);
                if (newTaxesValue) {
                    tabs.push(tab);
                    tables.push('reimbursement-types');
                    rowIds.push(index);
                    newValues.push(newTaxesValue);
                    columnIds.push(taxesCellIndex);
                    if (taxesUpdated) updated.taxesChanged = false;
                }
            }
        }

        if (newValues) {
            this.props.valuesChange({
                tabs,
                tables,
                rowIds,
                values: newValues,
                columnIds,
                ...updated,
            });
        }
    }

    onTableValueChange(tableIdentifier, rowCode, event, columnIndex, precomputedValues) {
        const isCurrentTab = this.props.tab.includes('current');
        const tabs =  isCurrentTab ? [this.props.tab, this.props.tab , 'proforma-reimbursement-tab' , 'proforma-reimbursement-tab'] : new Array(2).fill(this.props.tab);
        const tables = isCurrentTab ? new Array(4).fill(tableIdentifier) : new Array(2).fill(tableIdentifier);
        const rowIds = isCurrentTab ? new Array(4).fill(rowCode) : new Array(2).fill(rowCode);

        if (event.currentTarget.hasOwnProperty('checked')) {
            const checked = event.currentTarget.checked;

            if (tableIdentifier === 'reimbursement-types' && columnIndex === camCheckboxCellIndex) {
                const camValue = CurrentReimbursement.recomputeCamByIndex(this.props.tab, this.props.tabs, precomputedValues, rowCode, checked);
                const mgmtValue = CurrentReimbursement.recomputeMgmtByIndex(this.props.tab, this.props.tabs, precomputedValues, rowCode, null, null, camValue);
                const values = [checked, camValue, mgmtValue];
                const columnIds = [columnIndex, camCellIndex, mgmtCellIndex];
                tabs.splice(2, 0, this.props.tab);
                tables.push(tableIdentifier);
                rowIds.push(rowCode);
                if (isCurrentTab) {
                    tabs.push('proforma-reimbursement-tab');
                    tables.push(tableIdentifier);
                    rowIds.push(rowCode);
                    values.push(checked, camValue, mgmtValue);
                    columnIds.push(columnIndex, camCellIndex, mgmtCellIndex);
                }
                this.props.valuesChange({tabs, tables, rowIds, values, columnIds});
                return;
            }

            if (tableIdentifier === 'reimbursement-types' && columnIndex === mgmtCheckboxCellIndex) {
                const mgmtValue = CurrentReimbursement.recomputeMgmtByIndex(this.props.tab, this.props.tabs, precomputedValues, rowCode, checked);
                const values = [checked, mgmtValue];
                const columnIds = [columnIndex, mgmtCellIndex];
                if (isCurrentTab) {
                    values.push(checked, mgmtValue);
                    columnIds.push(columnIndex, mgmtCellIndex);
                }
                this.props.valuesChange({tabs, tables, rowIds, values, columnIds});
                return;
            }

            if (tableIdentifier === 'reimbursement-types' && columnIndex === insuranceCheckboxCellIndex) {
                const insuranceValue = CurrentReimbursement.recomputeInsuranceByIndex(this.props.tab, this.props.tabs, precomputedValues, rowCode, checked);
                const values = [checked, insuranceValue];
                const columnIds = [columnIndex, insuranceCellIndex];
                if (isCurrentTab) {
                    values.push(checked, insuranceValue);
                    columnIds.push(columnIndex, insuranceCellIndex);
                }
                this.props.valuesChange({tabs, tables, rowIds, values, columnIds});
                return;
            }

            if (tableIdentifier === 'reimbursement-types' && columnIndex === taxesCheckboxCellIndex) {
                const taxesValue = CurrentReimbursement.recomputeTaxesByIndex(this.props.tab, this.props.tabs, precomputedValues, rowCode, checked);
                const values = [checked, taxesValue];
                const columnIds = [columnIndex, taxesCellIndex];
                if (isCurrentTab) {
                    values.push(checked, taxesValue);
                    columnIds.push(columnIndex, taxesCellIndex);
                }
                this.props.valuesChange({tabs, tables, rowIds, values, columnIds});
                return;
            }

            this.props.valueChange(this.props.tab, tableIdentifier, rowCode, checked, columnIndex);
        } else {
            const value = event.currentTarget.value;
            let cam = null, adminFee = null;

            if (tableIdentifier === 'reimbursement-types' && columnIndex === camCellIndex)
                cam = value;
            if (tableIdentifier === 'reimbursement-types' && columnIndex === adminFeeCellIndex)
                adminFee = value;
            if (cam || adminFee) {
                const mgmtValue = CurrentReimbursement.recomputeMgmtByIndex(this.props.tab, this.props.tabs, precomputedValues, rowCode, null, adminFee, cam);
                const values = [value, mgmtValue];
                const columnIds = [columnIndex, mgmtCellIndex];
                if (isCurrentTab) {
                    values.push(value, mgmtValue);
                    columnIds.push(columnIndex, mgmtCellIndex);
                }
                this.props.valuesChange({tabs, tables, rowIds, values, columnIds});
                return;
            }

            if (this.props.tab === 'current-reimbursement-tab') {
                this.props.valuesChange({
                    tabs: ['current-reimbursement-tab', 'proforma-reimbursement-tab'],
                    tables: [tableIdentifier, tableIdentifier],
                    rowIds: [rowCode, rowCode],
                    values: [value, value],
                    columnIds: [columnIndex, columnIndex],
                });
                return;
            }

            this.props.valueChange(this.props.tab, tableIdentifier, rowCode, value, columnIndex);
        }
    }

    static renderStaticValueCell(tabs, cell, domKey, isHighlighted, highlightType, rowIndex, precomputedValues) {
        if (cell.empty) {
            return (<td className='value-cell empty' key={domKey}/>)
        }
        const displayValue = cell.getComputedValue(tabs, rowIndex, precomputedValues).displayValue;
        return (
            <td className={`${(displayValue === '-' ? 'center-dashes' : '')} value-cell ${isHighlighted ? highlightType : ''} ${(cell.styleClasses && cell.styleClasses.length ? cell.styleClasses : '')}`}
                key={domKey}>
                <span className='text value'>{displayValue}</span>
                {cell.tooltip ? <span className='cell-tooltip'>{cell.tooltip}</span> : null}
            </td>
        );
    }

    renderEditableValueCell(tableIdentifier, rowKey, cell, columnIndex, isHighlighted, highlightType, forceStatic, precomputedValues) {
        if (forceStatic || cell.forceStatic) {
            return (
                <td className={`value-cell ${isHighlighted ? highlightType : ''} ${(cell.styleClasses && cell.styleClasses.length ? cell.styleClasses : '')} ${cell.forceStatic ? 'force-static' : '' }`}
                    key={`${rowKey}-${columnIndex}`}>
                    <span className="text value">
                        {cell.value && cell.unit === '$' ? cell.unit : null}
                        {cell.value ? cell.value : null}
                        {cell.value && cell.unit !== '$' ? cell.unit : null}
                    </span>
                </td>
            )
        }

        if (cell.type === 'boolean') {
            return (
                <td className={`value-cell checkbox-cell`} key={`${rowKey}-${columnIndex}`}>
                    <input type="checkbox" checked={cell.value}
                           onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex, precomputedValues)}/>
                </td>
            )
        }

        return (
            <td className={`value-cell ${isHighlighted ? highlightType : ''} editable-cell ${(cell.styleClasses && cell.styleClasses.length ? cell.styleClasses : '')}`}
                key={`${rowKey}-${columnIndex}`}>
                <label
                    className={`${cell.type} ${(cell.type === 'number' && (cell.unit === '$' || cell.unit === '%' || cell.unit === 'SF' || cell.unit === 'Acres' || cell.unit === 'Years' || cell.unit === 'bps')) ? 'formatted-number-label' : ''}`}>
                    <input value={cell.value}
                           onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex, precomputedValues)}
                           type={cell.type !== 'date' ? cell.type : null}
                           placeholder={cell.type === 'date' ? 'MM/DD/YYYY' : (cell.unit || cell.placeholder)}/>
                    <div className="input-display-value">
                        {cell.value && cell.unit === '$' ? cell.unit : null}
                        {cell.value ?
                            tableIdentifier === 'reimbursement-types' && [camCellIndex, mgmtCellIndex, insuranceCellIndex, taxesCellIndex].includes(columnIndex) ?
                                Number(cell.value).toFixed(2) : BaseTabComponent.addCommasToNumber(cell.value)
                            : null}
                        {cell.value && cell.unit !== '$' ? (cell.unit === 'Acres' || cell.unit === 'SF' ? ` ${cell.unit}` : cell.unit) : null}
                        </div>
                </label>
            </td>
        );
    }

    renderMatrixTable(tables, tableIdentifier, precomputedValues, forceStaticCells) {
        const table = tables[tableIdentifier];

        const tableRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            let rowIsHighlighted = false;
            let rowHighlightType = 'highlighted';

            if (row.highlightable) {
                rowIsHighlighted = row.isHighlighted(this.props.tabs, key);
                if (row.highlightType) {
                    rowHighlightType += '-' + row.highlightType;
                }
            }

            return <tr key={key} className={key}>
                {row.valueCells.map((cell, index) => {
                    if (cell === null) {
                        return <td key={index} className='invisible'/>
                    }

                    if (cell.hidden) {
                        return;
                    }

                    let isHighlighted = rowIsHighlighted;
                    let highlightType = rowHighlightType;
                    if (cell.highlightable) {
                        isHighlighted = cell.isHighlighted(this.props.tabs, key);
                        if (cell.highlightType) {
                            highlightType += '-' + cell.highlightType;
                        }
                    }

                    if (cell.editable) {
                        return this.renderEditableValueCell(tableIdentifier, key, cell, index, isHighlighted, highlightType, forceStaticCells, precomputedValues);
                    } else {
                        const domKey = `${key}-${index}`;
                        return CurrentReimbursement.renderStaticValueCell(this.props.tabs, cell, domKey, isHighlighted, highlightType, key, precomputedValues);
                    }
                })}
            </tr>
        });

        return (
            <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                <tbody>
                {table.headerRow && table.headerRow.length ?
                    <tr>{table.headerRow.map((cell, index) => {
                        if (cell === null) {
                            return <td className='header-cell empty' key={index}/>
                        }
                        return (
                            <td className='header-cell' key={index}>
                                <div className='text'>{cell}</div>
                            </td>
                        )
                    })}</tr>
                    : null
                }

                {tableRows}

                {table.footerRow && table.footerRow.valueCells && table.footerRow.valueCells.length ?
                    <tr className='footer-row'>{Object.keys(table.footerRow.valueCells).map((key) => {
                        const cell = table.footerRow.valueCells[key];
                        if (cell) {
                            return (
                                <td key={key}>
                                    <div className='text'>{cell.getComputedValue(tables).displayValue}</div>
                                </td>
                            );
                        }
                        return <td className='invisible' key={key}/>;
                    })}</tr>
                    : null
                }
                </tbody>
            </table>
        )
    }


    onTableScroll(event) {
        const mainTable = event.target;
        const scrollTop = mainTable.scrollTop;
        const scrollLeft = mainTable.scrollLeft;
        const topHeader = document.getElementById('table-top');
        const leftColumn = document.getElementById('table-left');

        topHeader.style.transform = `translateX(-${scrollLeft}px)`;
        leftColumn.style.transform = `translateY(-${scrollTop}px)`;
    }


    render() {
        const rrTab = this.props.tab.includes('proforma') ? this.props.tabs['proforma-rr-tab'] : this.props.tabs['current-rr-tab'];
        const reimbursementTab = this.props.tabs[this.props.tab];

        // Computing heavily-used values at the start of the render.
        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.props.tabs);

        return (
            <div className="CurrentRR CurrentReimbursement">

                <div className="title-container">
                    {BaseTabComponent.renderTableContainer(rrTab.tables[''], [
                        this.renderMatrixTable(rrTab.tables, 'location-date-information', precomputedValues)
                    ])}
                </div>

                <div className="full-table">
                    <div className="top-left">
                        {this.renderMatrixTable(rrTab.tables, 'top-left', precomputedValues)}
                    </div>
                    <div className="top" id="table-top">
                        {this.renderMatrixTable(reimbursementTab.tables, 'header', precomputedValues)}
                    </div>

                    <div className="left" id="table-left">
                        <div>
                            {this.renderMatrixTable(rrTab.tables, 'general-information', precomputedValues, true)}
                        </div>
                        {this.renderMatrixTable(rrTab.tables, 'sumed-general-information', precomputedValues)}
                    </div>

                    <div className="main-table" onScroll={this.onTableScroll}>
                        <div className="default-tables" ref={this.defaultTableRef}>
                            {this.renderMatrixTable(reimbursementTab.tables, 'detailed-information', precomputedValues)}
                            {this.renderMatrixTable(reimbursementTab.tables, 'sumed-detailed-information', precomputedValues)}
                        </div>

                        <div className="helper-tables">
                            {this.renderMatrixTable(reimbursementTab.tables, 'reimbursement-types', precomputedValues)}
                            {this.renderMatrixTable(reimbursementTab.tables, 'reimbursable-op-ex', precomputedValues)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
